import { render, staticRenderFns } from "./layout-auth.vue?vue&type=template&id=83004910&scoped=true&"
import script from "./layout-auth.vue?vue&type=script&lang=js&"
export * from "./layout-auth.vue?vue&type=script&lang=js&"
import style0 from "./layout-auth.vue?vue&type=style&index=0&id=83004910&prod&lang=css&"
import style1 from "./layout-auth.vue?vue&type=style&index=1&id=83004910&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83004910",
  null
  
)

export default component.exports